import ReactMarkdown from 'react-markdown'
import { ConnectorSpec } from '@integration-app/sdk'

import Container from 'routes/components/Layout/Container'
import { DefaultPageLayout } from 'routes/layouts'
import { HeadMetatags } from '../../components/HeadMetatags'
import NavLink from '../../components/NavLink'

import classes from './connector.module.css'
import iconArrowLeft from './arrow-left.svg'
import { LINKS } from 'routes/constants'
import { Article } from 'routes/components/Article'

export type GuideType = Record<string, string>

export default function ConnectorGuide({
  connector,
  guide,
}: {
  connector: ConnectorSpec
  guide: GuideType
}) {
  return (
    <DefaultPageLayout>
      <HeadMetatags title={`${connector.name} Integration Development Guide`} />
      <Container className={classes.wrapper}>
        <div className={classes.heroBlock}>
          <NavLink
            href={`${LINKS.CONNECTORS}/${connector.key}`}
            className={classes.heroLink}
          >
            <img src={iconArrowLeft.src} alt='' />
            Back to connector
          </NavLink>
          <h1 className={classes.header}>
            <img
              src={connector.logoUri}
              className={classes.header_logo}
              alt='Logo'
            />
            {connector.name} Integration Development Guide
          </h1>
          <p className={classes.heroParagraph}>
            Add white-label customer-facing integration with {connector.name}{' '}
            into your app with just a few lines of code.
          </p>
        </div>
        <RenderGuide guide={guide} />
      </Container>
    </DefaultPageLayout>
  )
}

function RenderGuide({ guide }: { guide: GuideType }) {
  if (!guide) {
    return null
  }

  // See `getDocumentation` method in `connector-sdk/src/connector-manager/connector-manager.ts`
  const docFiles = ['README', 'about', 'configuration', 'testing']
  const documentationKey = docFiles.find((key) => !!guide[key])
  if (!documentationKey) {
    return null
  }

  return (
    <Article.StyledTypography>
      <ReactMarkdown>{guide[documentationKey]}</ReactMarkdown>
    </Article.StyledTypography>
  )
}
